<template>
  <div style="display:inline-block; margin-right:25px; margin-bottom:10px;">

    <button
      v-if="buttonType == 'button'"
      @click="deposit=true;"
      style="width:250px;"
    >
      {{buttonName}}
    </button>

    <a v-if="buttonType == 'link'" @click="deposit=true;">{{buttonName}}</a>

    <modalWindow
      v-if="deposit && !$parent.transaction"
      @close="deposit=false;pick=null"
    >
      <div class="titlebar">Storten</div>
      <template
        v-if="
          ($parent.intakeAdmin.beleggen.brand == 'Doelbeleggen' && pick == 'bank')
          || $parent.intakeAdmin.beleggen.brand !== 'Doelbeleggen'
        "
      >
        <div class="inset">
          U kunt een geldbedrag op uw beleggingsrekening bijstorten via onderstaand IBAN-nummer.
          Vermeld in de omschrijving uw intakenummer.
          <br>
          <br>
          <table>
            <tr style="background-color:#fff;">
              <th>Tenaamstelling</th>
              <td>Stichting Collectieve Beleggersgiro</td>
            </tr>
            <tr style="background-color:#fff;"><th>IBAN</th><td>NL 85 ABNA 042 619 8212</td></tr>
            <tr><th>Omschrijving</th><td>Vragenlijst {{this.getQueryVariable('intake')}}</td></tr>
          </table>
        </div>
        <a
          class="block-button"
          @click="pick=!pick"
          v-if="$parent.intakeAdmin.beleggen.brand == 'Doelbeleggen'"
        >
          <awesomeIcon icon="chevron-left"/> Terug
        </a>
      </template>
      <template v-else>
        <span v-if="msg" class="form-error">
          {{ msg }}
        </span>
        <div class="form-notice">
          Let op: Uw {{overdracht ? 'overdracht' : 'inleg'}} kan alleen worden geaccepteerd vanuit
          uw {{overdracht ? 'BV rekening' : 'tegenrekening'}}
          <b>{{iban.toUpperCase()}}</b>.
        </div>
        <form @submit.prevent class="inset">
          <template v-if="identify">
            <label style="padding-left: 18px;">Bedrag</label>
            <p class="identifyColor">&euro; 0,01</p>
          </template>
          <customInput v-else v-model="amount" type="money" label="Bedrag"/>
          <p class="msg" v-if="amount > 999">
            Let op: Wanneer u via iDeal een hoog geldbedrag overboekt, kan afhankelijk van de bank
            een maximum gelden.
          </p>
          <select v-model="selected">
            <option value="" disabled selected>Kies een bank</option>
            <option v-for="issuer in issuers" :key="issuer.id" :value="issuer.id">
              {{issuer.name}}
            </option>
          </select>
          <button
            v-if="identify"
            @click="newIdeal(selected, 0.01)"
          >
            iDeal identificatiestorting
          </button>
          <button
            v-else
            @click="newIdeal(selected, amount)"
          >
            iDeal storting (&euro; {{formatPrice(amount)}})
          </button>
          <button @click="pick='bank'" v-if="!pick">
            Bank overschrijving
          </button>
        </form>
      </template>
    </modalWindow>

  </div>
</template>

<script>
import { findIndex } from 'lodash-es';

export default {
  name: 'IntakeDepositWidget',
  props: {
    buttonName: {
      default: 'Storten',
      type: String,
    },
    buttonType: {
      default: 'button',
      type: String,
    },
    identify: {
      default: false,
      type: Boolean,
    },
    iban: {
      type: String,
    },
    overdracht: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      amount: '1',
      cashflow: [],
      issuers: [],
      update: false,
      deposit: false,
      newSat: null,
      pick: null,
      bankSelect: null,
      selected: null,
      msg: '',
    };
  },
  created() {
    this.sdk.getIssuers((response) => {
      if (response.status === 200) {
        this.issuers = response.data;
        const contra = `${this.iban}`.toUpperCase().replace(/\s/g, '');
        const found = contra.length > 0
          ? findIndex(this.issuers, (o) => o.id.includes(
            contra.substr(4, 4),
          ))
          : 0;
        this.selected = response.data[found > 0 ? found : 0].id;
      }
    });
  },
  methods: {
    newIdeal(bank, value) {
      this.deposit = false;
      this.sdk.intakeIdeal(
        this.getQueryVariable('intake'),
        bank,
        value,
        (response) => {
          if (response.status === 200) {
            window.onbeforeunload = () => {};
            window.location.href = response.data;
          } else if (response.status === 429) {
            this.deposit = true;
            if (response.data.transactionTimeout === 'timeout') {
              this.msg = 'Te veel transactiepogingen in de laatste minuut, probeer het over een paar minuten nog eens.';
            } else if (response.data.transactionTimeout === 'ban') {
              this.msg = 'Te veel transactiepogingen in de laatste 12 uur, probeer het over 24 uur nog eens.';
            }
          }
        },
      );
    },
  },
};
</script>
<style lang="scss" scoped>
  .identifyColor {
    font-size: 15px;
    color: $color-highlight;
    margin: 10px 0px 10px 0px !important;
  }
  a { cursor: pointer; }
</style>
